import React, { useCallback, useEffect, useState } from 'react';
import UserHeader from './UserHeader';
import ProfileContainer from './ProfileContainer';
import { Outlet } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import axiosInsatnace, { getAllDashboardData } from '../../asiosConfig';
import { CircularProgress } from '@mui/material';
import PremiumModal from './PremiumModal';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../../services/firebaseConfig';

export const Layout = () => {
    const [profileData, setProfileData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);
    const currentUsername = localStorage.getItem('username');
    useEffect(() => {
        const fetchUnreadMessages = () => {
            // Firestore query for conversations
            const q = query(
                collection(db, "conversations"),
                where("lastMessage.status", "==", "sent")
            );

            // Real-time listener for updates
            const unsubscribe = onSnapshot(q, (snapshot) => {
                let count = 0;

                snapshot.forEach((doc) => {
                    const data = doc.data();
                    const lastMessage = data.lastMessage;

                    // Check if the current user is part of the conversation
                    if (
                        lastMessage &&
                        lastMessage.senderId !== currentUsername &&
                        (data.participants?.includes(currentUsername) || data.receiverId === currentUsername)
                    ) {
                        count++; // Increment count for unread messages in relevant conversations
                    }
                });

                setUnreadCount(count); // Update unread count state
            });

            return unsubscribe; // Cleanup listener
        };

        const unsubscribe = fetchUnreadMessages();
        return () => unsubscribe(); // Cleanup on unmount
    }, [currentUsername]);


    const fetchDashboard = useCallback(async () => {
        if (loading) {
            try {
                const response = await getAllDashboardData();
                if (response.status === 200 || response.status === 201) {
                    const userInfo = response.data.DASHBOARD.user_info;
                    const gender = userInfo.username ? userInfo.username.charAt(0) : null;
                    localStorage.setItem('gender', gender);
                    setProfileData(userInfo);
                    localStorage.setItem('profilePic', userInfo.photo);
                    localStorage.setItem('account_type', userInfo.membership_type || 'Free');

                    // Handle popup logic here
                    const expiryDate = new Date(userInfo.package_expiry_date); // Assuming you have this data
                    const currentDate = new Date();
                    const diffInDays = Math.ceil((expiryDate - currentDate) / (1000 * 60 * 60 * 24));

                    if (diffInDays <= 7 && diffInDays >= 0) {
                        const lastPopupDate = localStorage.getItem('lastPopupDate');
                        const today = new Date().toDateString();

                        if (lastPopupDate !== today) {
                            setShowPopup(true);
                            localStorage.setItem('lastPopupDate', today);
                        }
                    }
                } else {
                    toast.error("Something went wrong");
                }
            } catch (error) {
                toast.error(error.response?.data?.message || 'Something went wrong');
            } finally {
                setLoading(false);
            }
        }
    }, [loading]);

    useEffect(() => {
        fetchDashboard();
    }, [fetchDashboard]);

    const handleClosePopup = () => setShowPopup(false);

    if (loading) return <CircularProgress />;

    return (
        <div>
            <UserHeader />
            <section className="middelBlock">
                <div className="container">
                    <div className="row">
                        <ProfileContainer profileData={profileData} unreadCount={unreadCount} />
                        <Outlet replace />
                    </div>
                </div>
            </section>

            {showPopup && (
                <PremiumModal
                    onClose={handleClosePopup}
                    daysLeft={Math.ceil(
                        (new Date(profileData?.package_expiry_date) - new Date()) /
                        (1000 * 60 * 60 * 24)
                    )}
                />
            )}

            <ToastContainer />
        </div>
    );
};
